import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthenticationService } from '@app/core/auth/authentication.service';
import { NgxLoadingBar } from '@ngx-loading-bar/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    NgxLoadingBar,
    RouterOutlet,
  ],
})
export class AppComponent {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly translate = inject(TranslateService);

  constructor() {
    this.translate.addLangs(['de', 'fr', 'it', 'en']);
    this.translate.setFallbackLang('de');

    const user = this.authenticationService.getUser();
    if (user) {
      this.translate.use(user.language);
    }
  }
}
